module.exports = "./img/eefce5ac794077245b2281bd18dd1296.jpg";